import { matchPath } from "react-router-dom";

export const findMatchingRoute = (pathname, routeList) => {
  for (const route of routeList) {
    const match = matchPath({ path: route.path, end: true }, pathname);
    if (match) {
      return { route, params: match.params };
    }
  }
  return null;
};

export const interpolateBackTo = (template, params = {}) =>
  template.replace(/:([A-Za-z0-9_]+)/g, (_, key) => params[key] ?? "");

export const handlePageBack = ({ route, params }, location, navigate) => {
  if (typeof route.onBack === "function") {
    route.onBack({ params, location, navigate });
    return;
  }

  if (window.history.length > 1) {
    navigate(-1);
    return;
  }

  if (route.backTo) {
    navigate(interpolateBackTo(route.backTo, params));
    return;
  }

  navigate("/businesses");
};
